import { useEffect } from 'react'
import { createPortal } from 'react-dom'

// Modale primitive — createPortal (CONVENTIONS : evite les bugs CSS fixed+transform)
// + a11y (role=dialog, aria-modal, Escape) + DESIGN-GUIDE (rounded-3xl / liquid glass).
// variant : center (desktop centre) | sheet (bottom-sheet mobile)

export default function Modal({ open, onClose, title, variant = 'center', className = '', children }) {
  useEffect(() => {
    if (!open) return undefined
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  const panel =
    variant === 'sheet'
      ? // max-h + scroll interne : une feuille plus haute que l'ecran doit defiler,
        // jamais etre coupee par le viewport (retour terrain wallet v0.73.1)
        'w-full rounded-t-3xl panel-slide-up max-h-[85dvh] overflow-y-auto overscroll-contain'
      : 'w-full max-w-md rounded-3xl max-h-[90dvh] overflow-y-auto overscroll-contain'
  const wrapper =
    variant === 'sheet' ? 'items-end' : 'items-center justify-center p-4'

  return createPortal(
    <div className={`fixed inset-0 z-50 flex ${wrapper}`} role="dialog" aria-modal="true">
      <button
        aria-label="Fermer"
        className="absolute inset-0 bg-black/40 backdrop-animate"
        onClick={onClose}
      />
      <div className={`relative glass-surface p-6 ${panel} ${className}`.trim()}>
        {title && (
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-base font-semibold text-ink">{title}</h2>
            <button
              aria-label="Fermer"
              onClick={onClose}
              className="w-8 h-8 rounded-xl flex items-center justify-center text-sm bg-card border border-card-border text-ink"
            >
              ×
            </button>
          </div>
        )}
        {children}
      </div>
    </div>,
    document.body,
  )
}
